import { useFxWorkspaceContext } from '@mobile-mapping/providers';
import { t } from '@trimble/i18n';
import type { JSX } from 'solid-js';

import {
  FX_WORKSPACE_LAYERS_ICON,
  FxWorkspaceEmptyState,
} from './FxWorkspaceEmptyState';

export const WorkspaceEmptyReferences = (): JSX.Element => {
  const fxWorkspace = useFxWorkspaceContext();

  return (
    <FxWorkspaceEmptyState
      icon={FX_WORKSPACE_LAYERS_ICON}
      title={t('mobileMapping.fxWorkspace.emptyWorkspace.title')}
      message={t('mobileMapping.fxWorkspace.emptyWorkspace.message')}
      dataTestId="workspace-empty-references"
      content={
        <modus-wc-button
          color="primary"
          shape="rectangle"
          size="md"
          type="button"
          variant="filled"
          data-testid="workspace-add-data-button"
          onClick={() => fxWorkspace.enterWorkspaceDataEditing()}
        >
          <i class="icon-font tc-icon-content-add" aria-hidden="true" />
          {t('mobileMapping.fxWorkspace.addData')}
        </modus-wc-button>
      }
    />
  );
};
